import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { Table } from 'reactstrap'
import KPIModal from './KPIModal'

export default function MobileKPI({ campaignId, campaignName, data, success, refetch, showSystemMessage }) {
    const [Modal, setModal] = useState({ isOpen: false, data: { id: '', is_hard_kpi: false, name: '', hide: false, description: '' }, isCreate: false })

    return (
        <div className="card mb-2">
            {Modal.isOpen && <KPIModal campaignName={campaignName} campaignId={campaignId} showSystemMessage={showSystemMessage} isOpen={Modal.isOpen} closeModal={() => setModal({ ...Modal, isOpen: false })} data={Modal.data} isCreate={Modal.isCreate} refetch={refetch} events={data.mobile_in_app_events} />}
            <Form>
                <div className="card-header d-flex justify-content-between align-items-center">
                    <div>Mobile KPIs</div>
                    <Button variant="warning" size="sm" onClick={() => setModal({ isOpen: true, data: { id: '', is_retirable: false, name: '', goal_type: 'p', description: '' }, isCreate: true })}>
                        Add KPI
                    </Button>
                </div>
                <Table striped bordered hover className="mb-0">
                    <thead>
                        <tr>
                            <th>KPI</th>
                            <th>Description</th>
                            <th>Hard</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <>
                            {data.kpis.length > 0 ? (
                                <>
                                    {data.kpis.map((event, index) => (
                                        <tr key={index}>
                                            <td>{event.name}</td>
                                            <td>{event.description}</td>
                                            <td>{event.is_hard_kpi ? 'Yes' : 'No'}</td>
                                            <td className="text-right">
                                                <Button variant="warning" size="sm" onClick={() => setModal({ isOpen: true, data: event, isCreate: false })}>
                                                    Edit
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="5">No Mobile App Events</td>
                                </tr>
                            )}
                        </>
                    </tbody>
                </Table>
            </Form>
        </div>
    )
}
